import NavDesktop from "./NavDesktop";
import NavMobile from "../SharedComponents/NavMobile";
import useNav from "../hooks/useNav";
import useNavProps from "../hooks/useNavProps";
import useUser from "../hooks/useUser";

function Nav({ isMobile }) {
  const { data: nav } = useNav();
  const { data: user } = useUser();
  const navProps = useNavProps(nav);

  return isMobile ? (
    <NavMobile {...navProps} isFooter={true} user={user} />
  ) : (
    <NavDesktop nav={nav} user={user} />
  );
}

export default Nav;
